import { URL_REGEX } from './regex'

export function convertEmailToName(email: string): string {
  const getEmailUsername = email.split('@')[0]
  return getEmailUsername.split('.').join(' ')
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function stripHTMLTags(originalString: string) {
  return originalString.replace(/(<([^>]+)>)/gi, ' ').trim()
}

export function truncateWordsByChar(str, maxLen, separator = ' ') {
  if (str.length <= maxLen) {
    return str
  }
  return str.substr(0, str.lastIndexOf(separator, maxLen)) + '...'
}

export function getUrlsFromText(text): string[] {
  return text.match(URL_REGEX)
}

export function extractYTIdFromUrl(url) {
  let regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  let match = url.match(regExp)
  if (match && match[7].length === 11) {
    return match[7]
  }
  return ''
}

export function removeTagsStyleAttribute(string: string, replacement = '') {
  return string.replace(
    /(style=[",'])([a-zA-Z0-9:;.\s()\-,]*)([",'])/gi,
    replacement
  )
}

/**
 * Concatenates an array of strings into a string, delimited with commas (,) with inclusion of the 'Oxford comma'
 *
 * @example
 * // returns "Geometri"
 * oxfordConcat(['Geometri'])
 * @example
 * // returns "Geometri dan Aljabar"
 * oxfordConcat(['Geometri', 'Aljabar'])
 * @example
 * // returns "Geometri, Aljabar, dan Kalkulus"
 * oxfordConcat(['Geometri', 'Aljabar', 'Kalkulus'])
 *
 * @param {string[]} texts - Array of strings to process
 * @param {string} [conjunction=dan] - Conjunction to insert before the last item
 * @returns {string} The concatenated string
 */
export function oxfordConcat(texts: string[], conjunction = 'dan') {
  const len = texts.length

  if (len <= 0) return ''
  if (len < 2) return texts[0]
  if (len < 3) return texts.join(` ${conjunction} `)

  let result = texts.slice()
  result[len - 1] = `${conjunction} ${texts[len - 1]}`

  return result.join(', ')
}
